/* ++++++++++ --------------- IMPORTS --------------- ++++++++++ */
// libraries
import { connect } from 'react-redux';
// component
import Embed from 'material/embeds/embed/embed';



/* ========== ~~~~~~~~~~ EMBED : CONTAINER ~~~~~~~~~~ ========== */
// map state
const mapStateToProps = ({ embedsState }, { contentId }) => {
    const contentStatus = embedsState.embedManagementState.contentStatus;
    return {
        selectedContentType: Object.keys(contentStatus.contents).length > 0 && !!contentStatus.selectedContent && contentStatus['contents'][contentStatus.selectedContent] !== undefined ?
            contentStatus['contents'][contentStatus.selectedContent]['contentType'] : null,
        embedLocationType: embedsState.embedManagementState.selectedEmbedStatus.selectedEmbedData.location
    };
};



/* ++++++++++ --------------- EXPORTS --------------- ++++++++++ */
export default connect(
    mapStateToProps
)(Embed);
